/**
 * The browser's IANA zone, sent with requests whose calendar periods ("this
 * month", "today") must be read in the viewer's own timezone.
 */
export const browserTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
